import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { MuiMarkdown } from 'mui-markdown';

export default function Terms() {
  return (
    <>
        <Box
          sx={{
            bgcolor: 'background.paper',
            pt: 10,
            pb: 6,
          }}
        >
          <Container maxWidth="lg">
            <Typography
              component="h1"
              variant="h2"
              color="text.primary"
              gutterBottom
              sx={{fontWeight:"bolder"}}
            >
             Términos de Servicio
            </Typography>

            <MuiMarkdown>{`

**Fecha de Vigencia:** 4 mayo 2025

Bienvenido a **CQurity Access**. Estos Términos de Servicio ("Términos") rigen su acceso y uso de nuestro Sistemas de Aparcamiento de Autos. Al acceder o utilizar nuestro sitio web o nuestros servicios, usted acepta estos Términos. Si no los acepta, le rogamos que no utilice nuestro Servicio.

<br>

<br>
#### 1. Uso del Servicio

Usted acepta utilizar el Servicio únicamente con fines lícitos y de conformidad con estos Términos. No debe utilizar el Servicio de ninguna manera que pueda dañar el sistema, comprometer su seguridad o interferir con otros usuarios.

<br>
#### 2. Cuentas de Usuario

Para utilizar ciertas funciones del Servicio, es posible que deba crear una cuenta. Usted acepta:
- Proporcionar información precisa y completa durante el registro
- Mantener la confidencialidad de sus credenciales de inicio de sesión
- Notificarnos de inmediato sobre cualquier uso no autorizado de su cuenta

Nos reservamos el derecho de suspender o cancelar su cuenta si la información proporcionada es inexacta, engañosa o infringe estos Términos.

<br>
<br>
#### 3. Reservas y acceso al estacionamiento

Nuestro Servicio puede permitirle:
- Ver las plazas de estacionamiento disponibles
- Reservar plazas de estacionamiento
- Obtener acceso automático a las plazas de estacionamiento

Todas las reservas están sujetas a disponibilidad. No garantizamos una plaza de estacionamiento específica a menos que se indique explícitamente.

<br>
<br>
#### 4. Tarifas y pagos

Algunas funciones del Servicio pueden requerir pago. Al usar estas funciones, usted acepta:
- Pagar todas las tarifas aplicables que se muestran al momento de la reserva o uso
- Proporcionar información de pago válida
- Autorizarnos a nosotros o a nuestro proveedor de pagos externo a procesar su pago

Todas las transacciones son definitivas a menos que se indique lo contrario.

<br>
<br>
#### 5. Propiedad Intelectual

Todo el contenido y la tecnología utilizados en este Servicio, incluyendo logotipos, diseños, software y marcas registradas, son propiedad de **CQURITY** o sus licenciantes. No puede copiar, modificar, distribuir ni utilizar nuestro contenido sin permiso por escrito.

<br>
<br>
#### 6. Conducta prohibida

No puede:
- Intentar piratear, realizar ingeniería inversa ni interrumpir el sistema.
- Utilizar el Servicio para participar en actividades ilegales.
- Falsificar su identidad o la información de su vehículo.

El incumplimiento de estas normas puede resultar en la suspensión o cancelación del acceso.

<br>
<br>
#### 7. Exención de garantías

El Servicio se proporciona "tal cual" y "según disponibilidad". No ofrecemos garantías, expresas ni implícitas, sobre la fiabilidad, disponibilidad o precisión del sistema.

<br>
<br>
#### 8. Limitación de Responsabilidad

En la medida máxima permitida por la ley, **CQURITY** no se responsabiliza de ningún daño directo, indirecto, incidental o consecuente derivado de su uso del Servicio, incluyendo disputas de estacionamiento, problemas de acceso o pérdida de datos.

<br>
<br>
#### 9. Privacidad

Su uso del Servicio también se rige por nuestra [Declaración de Privacidad](/privacy). Revísela para comprender cómo recopilamos, usamos y protegemos su información.

<br>
<br>
#### 10. Terminación

Nos reservamos el derecho de suspender o terminar su acceso al Servicio a nuestra entera discreción, con o sin previo aviso, por conducta que infrinja estos Términos o sea perjudicial de cualquier otra manera.

<br>
<br>
#### 11. Cambios a estos Términos

Podemos actualizar estos Términos en cualquier momento. Los cambios se publicarán en esta página con su fecha de entrada en vigor actualizada. El uso continuado del Servicio después de los cambios indica su aceptación de los Términos revisados.

<br>
<br>
#### 12. Ley Aplicable

Estos Términos se rigen por las leyes de [Insertar Jurisdicción]. Cualquier disputa se resolverá en los tribunales de [Insertar Jurisdicción].

<br>
<br>
#### 13. Contáctenos

Si tiene alguna pregunta sobre estos Términos, por favor, póngase en contacto con:

**CQURITY ACCESS** Dirección: Calle 22 NORTE #218, B,RESURGIMIENTO, 72370 PUEBLA, PUEBLA 
<br>
**Correo electrónico:** pagfe@cqurity.mx, cristian.serrano@cqurity.mx
<br>
**Teléfono:** 2211630363
            `}
                </MuiMarkdown>
          </Container>
          
        </Box>
      </>
  );
}